import { Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem("accessToken");
  const role = localStorage.getItem("role"); // "admin" expected

  if (!token) return <Navigate to="/" replace />;
  if (role !== "admin") return <Navigate to="/dashboard" replace />; // or 403 page

  return children;
};

export default AdminRoute;
